export class NoUserAnswer extends Error {
  constructor() {
    super(`NoUserAnswer`);
    this.name = 'NoUserAnswer';

    Error.captureStackTrace(this, NoUserAnswer);
  }
}
